import { render, staticRenderFns } from "./PropertyDashboardComponent.vue?vue&type=template&id=ab69f8e4"
import script from "./PropertyDashboardComponent.vue?vue&type=script&lang=js"
export * from "./PropertyDashboardComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports